export const env = { ...process.env, ...globalThis.env };